import React, { useState, useRef, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Alert,
  message,
  Button,
  Space,
  Typography,
  Divider,
} from "antd";
import { MailOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import { useAuth } from "./AuthContext";

const { Text, Title } = Typography;

const OtpVerificationModal: React.FC = () => {
  const {
    registrationVerify,
    otpModalVisible,
    onCloseOtpModal,
    onOpenLoginModal,
    onCloseRegisterModal,
    otpData,
  } = useAuth();

  const formRef = useRef<any>(null);
  const [verifying, setVerifying] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const onFinish = async (values: { otp: string }) => {
    if (!otpData) {
      setErrorMessage(
        "Verification data missing. Please try registering again."
      );
      return;
    }

    setVerifying(true);
    setErrorMessage("");

    try {
      const params = {
        UUID: otpData.uuid,
        OTP: values.otp,
      };

      await registrationVerify(params);

      // ✅ Success popup
      message.success("Verification successful! You can now login.");

      // Reset + close OTP modal
      formRef.current?.resetFields();
      onCloseOtpModal();

      // Open login modal
      onOpenLoginModal();
    } catch (err: any) {
      const errorMsg = err?.error_message || err?.message || "Invalid OTP code";
      setErrorMessage(errorMsg);
    } finally {
      setVerifying(false);
    }
  };

  const handleCancel = () => {
    formRef.current?.resetFields();
    setErrorMessage("");
    onCloseOtpModal();
  };

  const handleResendOtp = () => {
    // Implement resend OTP logic here
    message.info("OTP resent to your email");
  };

  return (
    // @ts-ignore
    <Modal
      title={
        <Space
          direction="vertical"
          align="center"
          style={{ width: "100%", textAlign: "center" }}
        >
          <SafetyCertificateOutlined
            style={{ fontSize: "24px", color: "#1890ff" }}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
          <Title level={4} style={{ margin: 0 }}>
            Verify Your Email
          </Title>
        </Space>
      }
      visible={otpModalVisible}
      footer={null}
      onCancel={handleCancel}
      destroyOnClose
      width={400}
      centered
    >
      {errorMessage && (
        <Alert
          message={errorMessage}
          type="error"
          showIcon
          style={{ marginBottom: "1em" }}
        />
      )}

      <div style={{ textAlign: "center", marginBottom: "1em" }}>
        <Text type="secondary">We sent a verification code to</Text>
        <br />
        <Text strong>{otpData?.email}</Text>
      </div>

      <Form
        ref={formRef}
        name="otp-form"
        layout="vertical"
        autoComplete="off"
        onFinish={onFinish}
        requiredMark={false}
      >
        <Form.Item
          label="Enter OTP Code"
          name="otp"
          rules={[
            { required: true, message: "Please enter the OTP code" },
            { len: 6, message: "OTP must be 6 characters" },
          ]}
        >
          <Input
            prefix={
              <SafetyCertificateOutlined
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            }
            placeholder="Enter 6-digit OTP"
            autoComplete="one-time-code"
            size="large"
            maxLength={6}
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: "16px" }}>
          <Button
            type="primary"
            htmlType="submit"
            loading={verifying}
            block
            size="large"
          >
            {verifying ? "Verifying..." : "Verify OTP"}
          </Button>
        </Form.Item>
      </Form>

      {/* <Divider plain>or</Divider>

      <div style={{ textAlign: "center" }}>
        <Text type="secondary">Didn't receive the code? </Text>
        <Button
          type="link"
          onClick={handleResendOtp}
          style={{ padding: 0, height: "auto" }}
        >
          Resend OTP
        </Button>
      </div> */}
    </Modal>
  );
};

export default OtpVerificationModal;
